import { ISalesExpenseInitialState } from "../../../types/sales/salesExpenseInterface";
import { SalesExpenseActionTypes, SalesExpenseActions } from "../../actionTypes/sales/saleExpenseActionTypes";


const initialState: ISalesExpenseInitialState = {
  expenseList: [],
  expenseData: {
    id: 0,
    bill_img: "",
    expense_value: 0,
    expense_type: "",
    employee_id: 0,
    request_closed_by: null,
    sales_activity_id: null,
    created_by: null,
    branch_id: null,
    hub_id: null,
    status: "",
    reason: "",
    description: "",
    createdAt: null,
    updatedAt: null,
    branch_data: {
      id: 0,
      branch_code: "",
      branch_name: "",
    },
    hub_data: {
      id: null,
      hub_name: "",
      hub_code: "",
    },
    employee_data: {
      id: 0,
      name: "",
      code: "",
    },
    sales_activity_data: {
      title: "",
    }
  },
  expenseListPageCount: 0,
};

export default function salesExpenseReducer(state = initialState, action: SalesExpenseActionTypes): ISalesExpenseInitialState {
  switch (action.type) {

    case SalesExpenseActions.SET_SALES_EXPENSE_LIST:
      return {
        ...state,
        expenseList: action.payload    
      };

    case SalesExpenseActions.SET_SALES_EXPENSE_LIST_PAGE_COUNT:
      return {
        ...state,
        expenseListPageCount: action.payload
      };

    case SalesExpenseActions.SET_SALES_EXPENSE_DATA_BY_ID:
      return {
        ...state,
        expenseData: action.payload
      }

    default:
      return state;
  }
}
